﻿import $ from 'jquery';

function initResourcesPodcastPlayer() {
    if ($("audio").length) {
        // element doesn't exist
    
            var audio = document.querySelector('audio');
            var play = document.querySelector('.pcastPlay');
            console.log(play);
            var pause = document.querySelector('.pcastPause');
            var skipForward = document.querySelector('.pcastJumpForward');
            var skipBackward = document.querySelector('.pcastJumpBackward');
            var duration = document.querySelector('.pcastDuration');
            var currentTime = document.querySelector('.pcastCurrenttime');
            var progress = document.querySelector('.pcastProgress');
            //var volume = document.querySelector('#volume');



            //volume.addEventListener('input', function (e) {
            //    audio.volume = this.value;
            //})

            var toHHMMSS = function (totalsecs) {
                var sec_num = parseInt(totalsecs, 10);
                var hours = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10) { hours = "0" + hours; }
                if (minutes < 10) { minutes = "0" + minutes; }
                if (seconds < 10) { seconds = "0" + seconds; }

                var time = hours + ':' + minutes + ':' + seconds;
                return time;
            }

            var setDuration = function (time) {
                duration.innerHTML = time;
            }

            //Sometimes the audio file loads before the DOM, sometimes it doesn't. This is how you can tell.
            if (!audio.duration) {
                audio.onloadedmetadata = function (e) {
                    //set podcast length
                    var length = toHHMMSS(audio.duration);
                    setDuration(length);

                    //set progress bar max
                    progress.setAttribute('max', Math.floor(audio.duration));

                    //attach timeupdate event
                    audio.addEventListener('timeupdate', function () {
                        progress.setAttribute('value', audio.currentTime);
                        currentTime.innerHTML = toHHMMSS(audio.currentTime);

                    });
                }
            }
            else {
                //set podcast length
                var length = toHHMMSS(audio.duration);
                setDuration(length);

                //set progress bar max
                progress.setAttribute('max', Math.floor(audio.duration));

                audio.addEventListener('timeupdate', function () {
                    progress.setAttribute('value', audio.currentTime);
                    currentTime.innerHTML = toHHMMSS(audio.currentTime);
                });
            }

            progress.addEventListener('click', function (e) {
                audio.currentTime = Math.floor(audio.duration) * (e.offsetX / e.target.offsetWidth);
            })


            /*Controls*/
            pause.style.display = 'none';
            play.addEventListener('click', function () {
                this.style.display = 'none';
                pause.style.display = 'block';
                audio.play();
                $(".podcastBarsContainer").css('visibility', 'visible');
            })

            pause.addEventListener('click', function () {
                this.style.display = 'none';
                play.style.display = 'block';
                audio.pause();
                $(".podcastBarsContainer").css('visibility', 'hidden');
            })

            skipBackward.addEventListener('click', function () {
                audio.currentTime -= 30;
            })

            skipForward.addEventListener('click', function () {
                audio.currentTime += 30;
            })
    }

    const bars = document.querySelectorAll('.bar');
    let intervalValue = 0;

    const delay = time => new Promise(resolve => setTimeout(resolve, time));

    [...bars].map((bar) => {
        delay(0).then(() => {
            setTimeout(() => {
                bar.style.animation = 'sound 500ms linear infinite alternate'
            }, intervalValue += 100)
        })
    })
}

initResourcesPodcastPlayer();